<template>
  <div class="question-list">

    <common-card card-title="问题列表">
      <template v-slot:right>
        <div class="manage-album">
          <el-button v-show="userDetailQuestionList.length==0"
            type="primary"
            class="none-border"
            size="small"
            plain
            @click="handleAdd"
          >新增</el-button>
          <el-button v-show="userDetailQuestionList.length!=0"
                     type="primary"
                     class="none-border"
                     size="small"
                     plain
                     @click="handleDelete"
          >删除</el-button>
        </div>
      </template>
      <div class="question-container-warpper">
        <el-row :gutter="40" type="flex">
          <el-col
            v-for="(item, index) in userDetailQuestionList"
            :key="index"
            :span="6"
          >
            <div class="title">{{ item.questionName }}</div>
            <div class="answer">{{ item.answer }}</div>
          </el-col>
        </el-row>
      </div>
    </common-card>
    <!-- 修改添加问题对话框 -->
    <el-dialog :title="dialogQuestion.title" :visible.sync="dialogQuestion.visible" width="700px">
      <el-form ref="questionForm" :model="questionForm"  label-width="100px">
        <el-form-item label="问题">
          <el-input v-model="questionForm.questionName"  label="请输入问题" disabled />
        </el-form-item>
        <el-form-item v-show="false" label="问题id">
          <el-input v-model="questionForm.questionId"   />
        </el-form-item>
        <el-form-item label="答案">
          <el-input v-model="questionForm.answer"  label="请输入答案"  />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleQuestionSubmit">确 定</el-button>
        <el-button @click="dialogQuestion.visible=false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonCard from '@/components/CommonCard'
import { getquestionlist, getQuestion,saveQuestion,deleteQuestion } from '@/api/user'
import { mapGetters } from 'vuex'
export default {
  name: 'QuestionList',
  components: {
    CommonCard
  },
  data() {
    return {
      userId: "",
      questionForm:{
        questionName:"",
        questionId:''
      },
      userDetailQuestionList:[],
      dialogQuestion:{
        visible:false
      }
    }
  },
  computed: {
  },
  created() {
    this.userId = this.$route.query.userId
    this.initQuestion()
  },
  methods:{

    handleDelete(){
      let id = this.userDetailQuestionList[0].id;
      console.log(id)
      deleteQuestion(id).then((res)=>{
        if(res.code=='00000'){
          this.$message.success("删除成功")
          this.initQuestion()
        }
      })
    },
    initQuestion(){
      getQuestion(this.userId).then((res) =>{
        if(res.code=='00000'){
          this.userDetailQuestionList = res.data
        }
      })
    },
    handleQuestionSubmit(){
      this.questionForm.userId = this.userId
      saveQuestion(this.questionForm).then((res) =>{
        if(res.code=='00000'){
          this.$message.success("保存成功")
          this.dialogQuestion.visible= false
          this.initQuestion()
          this.$refs['questionForm'].resetFields()
        }
      })
    },
    handleAdd(){
      this.dialogQuestion.visible = true
      getquestionlist().then((res) =>{
        if(res.code=='00000'){
            if (res.data.length>0){
              this.questionForm.questionName = res.data[0].questionName
              this.questionForm.questionId =res.data[0].id
            }
        }
      })
    }


  }
}
</script>

<style lang="scss" scoped>
.question-list {
  margin-top: 1.2rem;
  font-size: 12px;
  .question-container-warpper{
    margin-left:18px;
    margin-bottom: 10px;
    .title{
      margin-top: 20px;
      font-weight: bold;
    }
    .answer{
      margin-top: 18px;
      line-height: 18px;
      margin-bottom: 15px;
    }
  }
}
</style>

